import React, { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';

import {empty, getRandomUrlAppendage, logIt} from "__globals/global-functions";
var addOn = getRandomUrlAppendage("rd");

export const Countdowner = props => {

    logIt( "Countdowner component is called", null, false );

    const [currentPage, setCurrentPage] = useState(undefined);

    const [countdownOn, setCountdownOn] = useState(false);
    const [countdownTarget, setCountdownTarget] = useState(1897493441000);

    const countdownComplete = () => {
        return( <span>You are good to go!</span> );
    }

    const timerRef = useRef(null);

    // useEffect(() => {
    //     const targetElement = timerRef.current;
    //     if ( targetElement ) {
    //         //alert("it's alive")
    //     }
    // },[props]);
    //alert(props.countdownTarget)

    /** SET THE CURRENT PAGE **/
    useEffect(() => {
        if (!empty(props.promotion)) {
            if ( !empty(props.promotion.configuration?.config?.pages[props.configKey]) ) {
                setCurrentPage( props.promotion.configuration?.config?.pages[props.configKey] );
            }
        }
    }, [props.promotion]);

    /** SET THE COUNTDOWNER VARIABLES  **/
    useEffect(() => {
        if (!empty(currentPage)) {
            if ( !empty(currentPage.useCountdown) ) {
                setCountdownOn( currentPage.useCountdown );
                setCountdownTarget( currentPage.countdownTarget );
            }
        }
    }, [currentPage]);


    if (countdownOn) {
        return (
            <React.Fragment>
                {<div id="dv_countdown" ref={timerRef} >
                    <Countdown date={countdownTarget}>
                        {countdownComplete()}
                    </Countdown>
                </div>}
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment></React.Fragment>
        )
    }

}